import React from "react";
import ReactDOM from "react-dom/client";
import {
  RouterProvider,
  createHashRouter
} from "react-router-dom";

import BaristaInfo from "BaristaInfo.tsx";

import App from "./App.tsx";
import Menu from "./menu/Menu.tsx";

const router = createHashRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/menu",
    element: <Menu />,
  },
  {
    path: '/baristaInfo',
    element: <BaristaInfo />,
  }
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
